import React, { useState } from 'react';
import { ShoppingCartIcon, UserIcon, MenuIcon, XIcon, SparklesIcon } from 'lucide-react';
export function BabyHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="w-full" data-id="element-112">
      {/* Promotional Banner - Redesigned */}
      <div className="bg-baby-gradient-pink-blue text-white relative overflow-hidden" data-id="element-113">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full blur-2xl" data-id="element-114"></div>
        <div className="absolute bottom-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-2xl" data-id="element-115"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5 md:py-6" data-id="element-116">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center" data-id="element-117">
            {/* Icon */}
            <div className="flex items-center gap-2" data-id="element-118">
              <SparklesIcon className="w-5 h-5 sm:w-6 sm:h-6 animate-soft-pulse" data-id="element-119" />
              <span className="text-sm sm:text-base md:text-lg font-extrabold tracking-wide" data-id="element-120">
                LANZAMIENTO ESPECIAL
              </span>
              <SparklesIcon className="w-5 h-5 sm:w-6 sm:h-6 animate-soft-pulse" data-id="element-121" />
            </div>

            {/* Separator */}
            <span className="hidden sm:inline text-white/60 text-lg" data-id="element-122">•</span>

            {/* Main message */}
            <div className="text-base sm:text-lg md:text-xl font-bold leading-snug" data-id="element-123">
              <span className="inline-block" data-id="element-124">
                30 Recetas Seguras para Tu Bebé
              </span>
              <span className="hidden sm:inline mx-2" data-id="element-125">+</span>
              <span className="block sm:inline mt-1 sm:mt-0" data-id="element-126">
                Guías Completas
              </span>
            </div>
          </div>

          {/* Subtext */}
          <div className="text-center mt-2 text-xs sm:text-sm text-white/90 font-medium" data-id="element-127">
            🎁 Descarga instantánea • Garantía 30 días
          </div>
        </div>
      </div>

      {/* Trust Banner */}
      <div className="bg-baby-cream text-center py-2.5 sm:py-3 px-3 sm:px-4 text-xs sm:text-sm text-gray-700 font-medium border-b border-baby-pink-light/30" data-id="element-128">
        <span className="inline-flex items-center gap-2" data-id="element-129">
          <span data-id="element-130">⚡</span>
          <span data-id="element-131">Acceso digital instantáneo</span>
          <span className="hidden sm:inline text-baby-pink" data-id="element-132">•</span>
          <span className="hidden sm:inline" data-id="element-133">
            Basado en recomendaciones pediátricas
          </span>
        </span>
      </div>

      {/* Main Navigation */}
      <nav className="border-b border-baby-pink-light/30 sticky top-0 bg-white/95 backdrop-blur-baby z-50 shadow-baby-soft" data-id="element-134">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-3.5 md:py-4" data-id="element-135">
          <div className="flex items-center justify-between" data-id="element-136">
            {/* Logo */}
            <div className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold bg-baby-gradient-pink-blue bg-clip-text text-transparent leading-tight" data-id="element-137">
              30 Recetas para Bebés
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-138">
              <a href="#recetas" className="text-gray-700 hover:text-baby-pink transition text-sm lg:text-base font-medium" data-id="element-139">
                Ver Recetas
              </a>
              <a href="#testimonios" className="text-gray-700 hover:text-baby-blue transition text-sm lg:text-base font-medium" data-id="element-140">
                Testimonios
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-gray-700 hover:text-baby-pink transition rounded-baby hover:bg-baby-pink-light/30" aria-label="Menú" data-id="element-141">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-142" /> : <MenuIcon className="w-6 h-6" data-id="element-143" />}
            </button>

            {/* Desktop Icons */}
            <div className="hidden md:flex items-center space-x-1 sm:space-x-2" data-id="element-144">
              <button className="text-gray-700 hover:text-baby-pink transition p-2 sm:p-2.5 rounded-baby hover:bg-baby-pink-light/30" aria-label="Usuario" data-id="element-145">
                <UserIcon className="w-5 h-5" data-id="element-146" />
              </button>
              <button className="text-gray-700 hover:text-baby-blue transition p-2 sm:p-2.5 rounded-baby hover:bg-baby-blue-light/30" aria-label="Carrito de compras" data-id="element-147">
                <ShoppingCartIcon className="w-5 h-5" data-id="element-148" />
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && <div className="md:hidden mt-4 pb-4 border-t border-baby-pink-light/30 pt-4 animate-fade-in-up" data-id="element-149">
              <div className="flex flex-col space-y-3" data-id="element-150">
                <a href="#recetas" onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-baby-pink transition text-base font-medium py-2 px-3 rounded-baby hover:bg-baby-pink-light/30" data-id="element-151">
                  Ver Recetas
                </a>
                <a href="#testimonios" onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-baby-blue transition text-base font-medium py-2 px-3 rounded-baby hover:bg-baby-blue-light/30" data-id="element-152">
                  Testimonios
                </a>
              </div>
            </div>}
        </div>
      </nav>
    </header>;
}